import React from "react";
import { FormControl, InputAdornment } from "@mui/material";
import FieldErrorIcon from "./FieldErrorIcon";
import { fieldErrorMessages } from "./fieldErrorMessages";
import { PatternFormat } from "react-number-format";
import FieldBridge from "./FieldBridge";
import { StyledTextField } from "customStyled";
import { SelectWithInput } from "./Select";
import FormInputOuter from "./FormInputOuter";
import { withTrimHandler } from "utils/reactiveFormFunc";
import FormLabel from "./FormLabel";
import { useTranslation } from "react-i18next";
import { autocompleteToken, COUNTRY_CODES, phoneDigits, phoneFormat } from "utils";

// DE, IN, UA, US: UA numbers have 9 digits, the others 10 (utils/phone)
const countryCodeOption = COUNTRY_CODES.map(({ value, label }) => ({ value, label }));

const PhoneInputField = (props) => {
  const { t } = useTranslation("form");
  const { id, placeholder, label, autoComplete, countryCode } = props;

  return (
    <FormInputOuter {...props}>
      <FieldBridge
        name={"phone_number"}
        render={({ handler, pending, touched, invalid, ...other }) => {
          const isError = touched && invalid;
          const fieldLabel = label || t("cellphone");
          // the length rule is "minLength": the number of digits depends on the country
          const messages = isError
            ? fieldErrorMessages({
                errors: other.errors,
                label: fieldLabel,
                extra: { minLength: t("phoneDigits", { count: phoneDigits(countryCode) }) },
              })
            : [];
          return (
            <FormControl error={isError}>
              <FormLabel label={fieldLabel} required={true} id={id} />
              <StyledTextField
                id={id}
                name={id}
                height={44}
                placeholder={placeholder}
                autoComplete={autocompleteToken(autoComplete)}
                {...withTrimHandler(handler)}
                variant="outlined"
                // error={isError}
                endAdornment={
                  <InputAdornment position="end">
                    {isError ? <FieldErrorIcon messages={messages} /> : null}
                  </InputAdornment>
                }
                startAdornment={
                  <InputAdornment position="start">
                    <SelectWithInput
                      placeholder=""
                      name="countryCode"
                      id="countryCode"
                      ariaLabel={t("countryCode")}
                      variant="standard"
                      autoComplete="tel-country-code"
                      helperText={null}
                      optionList={countryCodeOption}
                    />
                  </InputAdornment>
                }
                sx={{
                  height:44,
                  "& .MuiFormControl-root": {
                    mr: 0,
                    "& .MuiInputBase-root": {
                      "&::before": {
                        borderBottomWidth: 0,
                      },
                      "&::after": {
                        borderBottomWidth: 0,
                      },
                      "& .MuiSelect-select": {
                        paddingBottom: 0,
                        paddingLeft: 0,
                      },
                    },
                    minWidth: "50px",
                  },
                  "& input ": {
                    padding: "0 9px",
                    fontSize: "16px",
                    fontWeight: 400,
                    lineHeight: "24px",
                    height: 'inherit'
                  },
                  pl: 0,
                }}
                inputComponent={PhoneFormatCustom}
                inputProps={{
                  countryCode,
                }}
              />
            </FormControl>
          );
        }}
      />
    </FormInputOuter>
  );
};

export default PhoneInputField;

const PhoneFormatCustom = React.forwardRef(function NumericFormatCustom(
  props,
  ref
) {
  const { onChange, countryCode, ...other } = props;
  return (
    <React.Fragment>
      <PatternFormat
        {...other}
        getInputRef={ref}
        onValueChange={(values, sourceInfo) => {
          onChange(values.value);
        }}
        valueIsNumericString={true}
        format={phoneFormat(countryCode)}
        mask=" "
        // allowEmptyFormatting
      />
    </React.Fragment>
  );
});
